import React, { useEffect, useCallback, useState} from 'react';
import UserScriptComponent from "components/effects/scripting/UserScriptComponent.js";
import {connect} from 'react-redux';

const ZScriptComponent = ({zobject, width, height}) => { 
    return (
        <UserScriptComponent
          isDraggable={true}
          setExpanded={() => []}
          width={width - 5}
          height={height - 40}
          disableSyntaxHelper={true}
          expanded={false}
          doc={zobject.effect.doc}
          sequencerEngine={zobject.sequencerEngine}
          effect={zobject.effect}/>
    );
};

const mapStateToProps = (state, props) => {
  return {
      width: props.zobject.width,
      height: props.zobject.height
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZScriptComponent);
